var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19577_32709)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19577_32709",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "#E9F7EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19577_32709)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M264.755 100.987C279.474 99.2647 293.255 90.8883 301.236 77.0647L324.58 36.6326C326.369 33.5332 325.32 29.5721 322.238 27.7927L304.765 17.7048C309.095 7.58572 305.413 -4.38863 295.69 -10.0018C285.968 -15.615 273.757 -12.8166 267.16 -4.01058L249.688 -14.0984C246.606 -15.8778 242.65 -14.8061 240.861 -11.7067L217.517 28.7253C209.537 42.5482 209.172 58.6755 215.04 72.2803C194.532 68.9469 173.185 78.1911 162.242 97.1444C160.453 100.244 161.502 104.205 164.584 105.984L260.803 161.536C263.885 163.315 267.84 162.244 269.629 159.144C280.57 140.194 277.903 117.085 264.758 100.989L264.755 100.987ZM289.207 1.22733C293.545 3.73179 295.029 9.30157 292.519 13.6482C290.011 17.9917 284.444 19.4948 280.106 16.9904C275.769 14.4859 274.285 8.91613 276.794 4.56951C279.302 0.226017 284.869 -1.27713 289.207 1.22733ZM262.777 8.43088C262.521 16.2933 266.369 24.0381 273.62 28.2248C280.872 32.4116 289.502 31.8705 296.184 27.7185L310.173 35.795L299.603 54.1025L238.219 18.6624L248.789 0.354892L262.777 8.43088ZM228.685 35.1739L231.735 29.8904L293.119 65.3304L290.069 70.614C280.264 87.5962 258.521 93.4614 241.596 83.6899C224.675 73.9204 218.879 52.1556 228.684 35.1735L228.685 35.1739ZM177.128 98.2563C188.864 84.1608 209.548 80.1665 226.095 89.7201L244.129 100.132C260.673 109.683 267.554 129.589 261.22 146.807L177.128 98.2563Z",
    fill: "#F6C047"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -22,
    r: 114,
    fill: "#C79428",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -22,
    r: 113.5,
    stroke: "#F6C047",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -22,
    r: 101.5,
    stroke: "#F6C047",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 -22C73.5 28.5341 32.5341 69.5 -18 69.5C-68.5341 69.5 -109.5 28.5341 -109.5 -22C-109.5 -72.5341 -68.5341 -113.5 -18 -113.5C32.5341 -113.5 73.5 -72.5341 73.5 -22Z",
    stroke: "#F6C047",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 -22C63.5 23.0112 27.0112 59.5 -18 59.5C-63.0112 59.5 -99.5 23.0112 -99.5 -22C-99.5 -67.0112 -63.0112 -103.5 -18 -103.5C27.0112 -103.5 63.5 -67.0112 63.5 -22Z",
    stroke: "#F6C047",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 -22C52.5 16.9361 20.9361 48.5 -18 48.5C-56.9361 48.5 -88.5 16.9361 -88.5 -22C-88.5 -60.9361 -56.9361 -92.5 -18 -92.5C20.9361 -92.5 52.5 -60.9361 52.5 -22Z",
    stroke: "#F6C047",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 -22C42.5 11.4132 15.4132 38.5 -18 38.5C-51.4132 38.5 -78.5 11.4132 -78.5 -22C-78.5 -55.4132 -51.4132 -82.5 -18 -82.5C15.4132 -82.5 42.5 -55.4132 42.5 -22Z",
    stroke: "#F6C047",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 -22C32.5 5.89037 9.89037 28.5 -18 28.5C-45.8904 28.5 -68.5 5.89037 -68.5 -22C-68.5 -49.8904 -45.8904 -72.5 -18 -72.5C9.89037 -72.5 32.5 -49.8904 32.5 -22Z",
    stroke: "#F6C047",
    strokeOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19577_32709",
    x1: -0.00000178282,
    y1: 31.7143,
    x2: 294.149,
    y2: 141.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD8A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineBackground);
export default __webpack_public_path__ + "static/media/OfflineBackground.0695d7ca0041fe59efc8003552eae1c7.svg";
export { ForwardRef as ReactComponent };